import React from 'react'
import { connect } from 'react-redux'
import PushNotifications from '../components/push-notifications'

const mapStateToProps = (state) => ({
  ...state.pushNotifications
})

const mapDispatchToProps = dispatch => ({
  setPage: payload => dispatch({type: 'PUSH_NOTIFICATIONS.SETPAGE', payload}),
  setPerPage: payload => dispatch({type: 'PUSH_NOTIFICATIONS.PAGESIZE', payload}),
  onCreate: payload => dispatch({type: 'PUSH_NOTIFICATIONS.CREATE', payload: payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(PushNotifications)
